import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { Spin } from "antd";
export default function RequireAuth() {
  const { isAuthenticated, isUserLoading } = useAuth();
  const location = useLocation();

  if (isUserLoading) {
    return (
      <main
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "40vh",
        }}
      >
        <Spin tip="Checking sign-in…" />
      </main>
    );
  }
  if (!isAuthenticated) {
    return <Navigate to={"/login"} state={{ from: location }} replace />;
  }
  return <Outlet />;
}
